import React, { useState, useEffect } from "react";
import { Paper } from "@mui/material";
import belowBg from "../../assets/yfs_label/product_yfs_label/container/yfslabel_below_bg.svg";
import unitsPlaceholder from "../../assets/yfs_label/product_yfs_label/container/house-yfs-label.svg";
import yfsSmallIcon from "../../assets/yfs_label/product_yfs_label/container/yfs-label-small-icon.svg";
import xIcon from "../../assets/yfs_label/product_yfs_label/container/x-icon.svg";
import "./index.css";
import { getReportLogo } from "../../apis/Report/Report";
import { YearTabContext } from "../../components/Skeleton";

const YFSLabelContainer = ({ children }) => {
  const year = React.useContext(YearTabContext);
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    getReportLogo({ setLogo: setLogo });
  }, [year]);
  return (
    <Paper
      elevation={0}
      sx={{
        p: 0,
        m: 2,
        mt: 1,
        maxWidth: "40vw",
        position: "relative",
        margin: "0 auto",
      }}
    >
      <div className="yfs-top-container">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            gap: "10px",
          }}
        >
          {
            <img
              src={logo ? logo : unitsPlaceholder}
              style={{
                width: logo ? 44 : 45,
                height: logo ? 44 : 34,
                zIndex: 1,
                objectFit: "cover",
              }}
              alt="Logo company"
            />
          }
          <img
            src={xIcon}
            style={{
              width: 14,
              height: 16,
              zIndex: 1,
            }}
            alt="x"
          />
          <img
            src={yfsSmallIcon}
            style={{
              width: 36,
              height: 38,
              zIndex: 1,
            }}
            alt="YFS small icon"
          />
        </div>
      </div>

      <div style={{ padding: "20px" }}>{children}</div>

      <div
        style={{
          width: "100%",
          position: "absolute",
          bottom: 0,
          left: 0,
        }}
      >
        <img src={belowBg} style={{ width: "100%" }} alt="YFS Label Bottom" />
      </div>
    </Paper>
  );
};

export default YFSLabelContainer;
